import Modal from "react-bootstrap/Modal";
import {useTheCellMapContext} from "../contexts/TheCellMapContext";
import "../css/loading.css";

/**
 * LoadingController is a React functional component responsible for displaying a loading modal.
 * It uses the state from `useTheCellMapContext` to determine whether the loading modal should be shown.
 * The modal displays a spinner to indicate a loading state and restricts user interaction by disabling
 * keyboard and backdrop dismiss functionality.
 */
const LoadingController = () => {
  const {loadingCount} = useTheCellMapContext();

  return (
    <>
      <Modal
        show={loadingCount > 0}
        backdrop="static"
        keyboard={false}
        centered
        contentClassName="loading-modal"
        dialogClassName="loading-dialog"
      >
        <div className="d-flex justify-content-center">
          <div className="spinner-border" role="status"></div>
        </div>
      </Modal>
    </>
  );
};

export default LoadingController;
